import { Calendar } from 'lucide-react';
import { CalendarShownEvent as CalendarShownEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: CalendarShownEventType;
}

export default function CalendarShownEvent({ event }: Props) {
  return (
    <EventShell
      color="red"
      icon={<Calendar className="w-3.5 h-3.5" />}
      title="Booking Calendar Shown"
      timestamp={event.created_at}
    >
      <p>{event.payload.calendar_type} calendar displayed</p>
    </EventShell>
  );
}
